import { styled } from '@mui/material'

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '16px',
  marginTop: '4px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column'
  }
}))

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center'
}))
